"use strict";
function debounceQuantityInput(callback, wait) {
    var timerId;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timerId);
        timerId = setTimeout(function () {
            callback.apply(void 0, args);
        }, wait);
    };
}
var cart = {
    add_product: function (id, qty, properties, callback) {
        callback = typeof callback !== "undefined" ? callback : false;
        var isCheckout = !!document.querySelector('.checkout');
        cart.add_item(id, qty, properties, function () {
            if (isCheckout) {
                window.onbeforeunload = function () {
                    window.scrollTo(0, 0);
                };
                location.reload();
            }
            else {
                cart.get_cart(function (data) {
                    cart.update_cart(data);
                    if (window.innerWidth > 992 && !isCheckout) {
                        cart.open_sticky_cart();
                    }
                    if (callback !== false)
                        callback(data);
                });
            }
        });
    },
    update_cart: function (cart_data) {
        var _a, _b, _c, _d;
        // Initialize default values
        cart_data = typeof cart_data !== "undefined" ? cart_data : false;
        if (!cart_data) {
            cart.get_cart(function (cart_data) {
                cart.update_cart(cart_data);
            });
        }
        else {
            var cartItems = document.querySelector(".sticky-cart .cart-items");
            if (cartItems) {
                cartItems.innerHTML = "";
            }
            cart_data.items.forEach(function (line_item, index) {
                var _a;
                var qtyDropdown = generateQuantityDropdown(line_item.quantity, index);
                var lineItemImageURL = new URL(line_item.image);
                lineItemImageURL.searchParams.set('width', '160');
                var item = "\n          <div class=\"cart-item\">\n            <a href=\"".concat(line_item.url, "\" class=\"image text-center\">\n              <span class=\"sr-only\">").concat(line_item.product_title, "</span>\n              <img\n                src=\"").concat(lineItemImageURL.toString(), "\"\n                alt=\"").concat(line_item.product_title, " cart image\"\n                loading=\"lazy\"\n              />\n            </a>\n            <div class=\"info text-left flex-1\">\n              <div class=\"remove\" data-index=\"").concat(index, "\">\n                <img\n                  src=\"https://cdn.shopify.com/s/files/1/0038/0377/5049/files/close.svg?1647611943264235054\"\n                  alt=\"Close side menu icon\"\n                />\n              </div>\n              <div class=\"text-uppercase brand\">").concat(line_item.vendor, "</div>\n              <div class=\"title\">").concat(line_item.product_title.replace(line_item.vendor, ""), "</div>\n              <div class=\"quantity-item-price d-flex align-items-start justify-content-between\">\n                <span class=\"quantity\">Qty: ").concat(qtyDropdown, "</span>\n                <span class=\"item-price\">").concat(generateLineItemPrice(line_item), "</span>\n              </div>\n            </div>\n          </div>\n        ");
                var element = document.createElement('div');
                element.innerHTML = item;
                (_a = document.querySelector(".sticky-cart .cart-items")) === null || _a === void 0 ? void 0 : _a.appendChild(element);
                document.querySelectorAll('.sticky-cart .cart-item .remove').forEach(function (removeButton) {
                    removeButton.addEventListener('click', function () {
                        var wrapper = removeButton.closest('.cart-item');
                        wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.add('cart-loader');
                        var index = parseInt(removeButton.getAttribute("data-index") || "0");
                        fetch('/cart/change.js', {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                line: index + 1,
                                quantity: 0
                            })
                        }).then(function () {
                            cart.update_cart(false);
                        });
                    });
                });
                document.querySelectorAll('.sticky-cart .cart-item select').forEach(function (stickCartQuantityInput) {
                    stickCartQuantityInput.addEventListener('change', debounceQuantityInput(function () {
                        var wrapper = stickCartQuantityInput.closest('.cart-item');
                        wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.add('cart-loader');
                        var value = parseInt(stickCartQuantityInput.value);
                        var index = parseInt(stickCartQuantityInput.getAttribute('data-index') || "0");
                        fetch("/cart/change.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({ line: index + 1, quantity: value })
                        }).then(function () {
                            cart.update_cart(false);
                        });
                    }, 600));
                });
            });
            // Update indicator
            var cartCounter = document.querySelector("header .cart-counter");
            if (cartCounter) {
                cartCounter.textContent = cart_data.item_count;
            }
            if (cart_data.total_discount != 0) {
                (_a = document.querySelector(".sticky-cart .sub-total")) === null || _a === void 0 ? void 0 : _a.classList.remove("d-none");
                var subTotalSpanElement = document.querySelector(".sticky-cart .sub-total span");
                if (subTotalSpanElement) {
                    subTotalSpanElement.textContent = "R" + (cart_data.original_total_price / 100).toFixed(2);
                }
                (_b = document.querySelector(".sticky-cart .discounts")) === null || _b === void 0 ? void 0 : _b.classList.remove("d-none");
                var discountsTotalSpanElement = document.querySelector(".sticky-cart .discounts span");
                if (discountsTotalSpanElement) {
                    discountsTotalSpanElement.textContent = "-R" + (cart_data.total_discount / 100).toFixed(2);
                }
            }
            else {
                (_c = document.querySelector(".sticky-cart .sub-total")) === null || _c === void 0 ? void 0 : _c.classList.add("d-none");
                (_d = document.querySelector(".sticky-cart .discounts")) === null || _d === void 0 ? void 0 : _d.classList.add("d-none");
            }
            var orderTotalSpanElement = document.querySelector(".sticky-cart .order-total span");
            if (orderTotalSpanElement) {
                orderTotalSpanElement.textContent = "R" + (cart_data.total_price / 100).toFixed(2);
            }
            var stickyLoader = document.querySelector(".sticky-cart .cart-loader");
            stickyLoader === null || stickyLoader === void 0 ? void 0 : stickyLoader.classList.add("d-none");
        }
    },
    open_sticky_cart: function () {
        var _a;
        (_a = document.querySelector('.sticky-cart')) === null || _a === void 0 ? void 0 : _a.classList.add('open');
    },
    get_cart: function (callback) {
        try {
            fetch('/cart.js').then(function (response) {
                response.json().then(function (cart) {
                    callback(cart);
                });
            });
        }
        catch (error) {
            console.log(error);
            callback(false);
        }
    },
    add_item: function (variant_id, quantity, properties, callback) {
        try {
            var newQuantity = quantity || 1;
            fetch('/cart/add.js', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    quantity: newQuantity,
                    id: variant_id,
                    properties: properties
                })
            }).then(function (response) {
                response.json().then(function (line_item) {
                    callback(line_item);
                });
            });
        }
        catch (error) {
            console.log(error);
            callback(false);
        }
    },
    attach_attributes: function (attributes, callback) {
        try {
            fetch('/cart/update.js', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    attributes: attributes
                })
            }).then(function (response) {
                response.json().then(function (cart) {
                    callback(cart);
                });
            });
        }
        catch (error) {
            console.log(error);
            callback(false);
        }
    }
};
var generateQuantityDropdown = function (selectedQuantity, index) {
    var select = document.createElement("select");
    for (var i = 1; i <= 25; i++) {
        var option = document.createElement("option");
        option.value = i.toString();
        option.textContent = i.toString();
        if (i == selectedQuantity) {
            option.setAttribute('selected', 'selected');
        }
        select.appendChild(option);
    }
    select.setAttribute("data-index", index.toString());
    select.classList.add("styled-select-input");
    return select.outerHTML;
};
var generateLineItemPrice = function (lineItem) {
    var lineItemPrice = "";
    if (lineItem.original_line_price != lineItem.line_price) {
        lineItemPrice += "<s class=\"discount-price\">R".concat((lineItem.original_line_price / 100).toFixed(2), "</s>");
    }
    lineItemPrice += "<span class=\"pay-price\">R".concat((lineItem.line_price / 100).toFixed(2), "</span>");
    return lineItemPrice;
};
